export const RailStateDataMetric = {
    RailcarCounts: 'RAILCAR COUNTS',
    TrainVolumes: 'TRAIN VOLUMES',
    CarTypeMixES: 'CAR TYPE MIXES',
    TravelTimes: 'TRAVEL TIMES'
};

export const RailStateDataMetrics = [
    RailStateDataMetric.RailcarCounts,
    RailStateDataMetric.TrainVolumes,
    RailStateDataMetric.CarTypeMixES,
    RailStateDataMetric.TravelTimes
];
